import {
    HttpEvent,
    HttpRequest,
    HttpInterceptorFn,
    HttpHandlerFn,
} from '@angular/common/http';
import { Observable } from 'rxjs';
export const SubdomainInterceptor: HttpInterceptorFn = (
    req: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
    const subdomain: any = localStorage.getItem('subdomain') ?? '';

    if (subdomain) {
        const cloned = req.clone({
            headers: req.headers.set('tenant-subdomain', subdomain),
        });
        return next(cloned);
    } else {
        return next(req);
    }
};
